var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"p-0"},[_c('b-row',{staticClass:"my-2 mx-0"},[_c('b-col',[_c('h5',{staticClass:"font-weight-bold"},[_vm._v("Edit equipments")]),_c('hr')])],1),_c('multi-equipment-edit-form',{attrs:{"componentData":_vm.componentData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }